export default {
    render: (args) => {
        const { x = 0, y = 0, color = 'lime', data = {} } = args
        const { status } = data
        const extraStyle = status === 'skipped' ? 'stroke: none;' : ''
        return `<circle cx="${x}" cy="${y}" style="fill:${color}; ${extraStyle}" r="8" />`
    },
}
